export const reportingEndpoints = (mpacBaseUrl, partnerId) => ({
  transactions: "".concat(mpacBaseUrl, "/rest/2/vendors/").concat(partnerId, "/reporting/sales/transactions/export"),
  licenses: "".concat(mpacBaseUrl, "/rest/2/vendors/").concat(partnerId, "/reporting/licenses/export"),
  'feedback-details': "".concat(mpacBaseUrl, "/rest/2/vendors/").concat(partnerId, "/reporting/feedback/details/export")
});
export const showOnlyToTheseReports = ['transactions', 'licenses', 'feedback-details'];